import React, { useEffect, useRef, useState } from "react";
import { change, Field } from "redux-form";
import { useDispatch } from "react-redux";

import { CustomCheckbox } from "../../../../../../../../common/customCheckbox";

export default function JobSwmsV3ForeseeableRescueScenariosSection({
  procedures = [],
  planIndex,
  loading
}) {
  const dispatch = useDispatch();
  const dragIndexRef = useRef(null);
  const [orderedProcedures, setOrderedProcedures] = useState(procedures);
  const [draggingIndex, setDraggingIndex] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    setOrderedProcedures(procedures);
  }, [procedures]);

  const updateProcedureOrder = (nextProcedures) => {
    setOrderedProcedures(nextProcedures);
    dispatch(change(
      "JobSwmsV3EmergencyPlansContainerForm",
      `plans[${planIndex}].procedures`,
      nextProcedures
    ));
    dispatch(change(
      "JobSwmsV3EmergencyPlansContainerForm",
      `plans[${planIndex}].procedure_order`,
      nextProcedures.map((procedure) => procedure.id !== undefined ? procedure.id : procedure.procedure_id)
    ));
  };

  return (
    <div className="container-fluid py-2">
      <div className="row pt-1">
        <div className="col-12">
          <div
            className="table-responsive"
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              border: "1px solid #e5e7eb",
              borderRadius: "6px"
            }}
          >
            <table className="table table-sm mb-0 ForeseeableRescueScenariosTable">
              <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                <tr>
                  <th style={{ width: "36%", paddingLeft: "24px" }}>Rescue Procedure</th>
                  <th style={{ width: "28%" }}>Scenario</th>
                  <th style={{ width: "28%" }}>Objective</th>
                  <th style={{ width: "8%", textAlign: "center" }}>Include</th>
                </tr>
              </thead>
              <tbody>
                {procedures.length === 0 ? (
                  <tr>
                    <td colSpan={4} style={{ color: "#6b7280", fontSize: "13px" }}>
                      No procedures available.
                    </td>
                  </tr>
                ) : orderedProcedures.map((procedure, index) => {
                  const procedureId = procedure.id !== undefined
                    ? procedure.id
                    : procedure.procedure_id;

                  return (
                    <tr
                      key={procedureId || index}
                      onDragEnter={(event) => {
                        if (loading || draggingIndex === null || draggingIndex === index) {
                          return;
                        }
                        event.preventDefault();
                        setHoveredIndex(index);
                      }}
                      onDragOver={(event) => {
                        if (loading || draggingIndex === null || draggingIndex === index) {
                          return;
                        }
                        event.preventDefault();
                        if (hoveredIndex !== index) {
                          setHoveredIndex(index);
                        }
                        if (event.dataTransfer) {
                          event.dataTransfer.dropEffect = "move";
                        }
                      }}
                      onDragLeave={(event) => {
                        if (!event.currentTarget.contains(event.relatedTarget)) {
                          setHoveredIndex((current) => (current === index ? null : current));
                        }
                      }}
                      onDrop={(event) => {
                        if (loading) {
                          return;
                        }
                        event.preventDefault();
                        const fromIndex = dragIndexRef.current;
                        if (fromIndex === null || fromIndex === index) {
                          dragIndexRef.current = null;
                          setDraggingIndex(null);
                          setHoveredIndex(null);
                          return;
                        }
                        const nextProcedures = [...orderedProcedures];
                        const [movedProcedure] = nextProcedures.splice(fromIndex, 1);
                        nextProcedures.splice(index, 0, movedProcedure);
                        updateProcedureOrder(nextProcedures);
                        dragIndexRef.current = null;
                        setDraggingIndex(null);
                        setHoveredIndex(null);
                      }}
                      onDragEnd={() => {
                        dragIndexRef.current = null;
                        setDraggingIndex(null);
                        setHoveredIndex(null);
                      }}
                      style={{
                        border: draggingIndex !== null && draggingIndex !== index && hoveredIndex === index
                          ? "1px solid #7C3AED"
                          : "1px solid transparent",
                        boxShadow: draggingIndex !== null && draggingIndex !== index && hoveredIndex === index
                          ? "0 0 0 2px rgba(124, 58, 237, 0.14)"
                          : "none",
                        transition: "border-color 120ms ease, box-shadow 120ms ease"
                      }}
                    >
                      <td>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          <span
                            aria-hidden="true"
                            title="Drag to reorder procedure"
                            draggable={!loading}
                            onDragStart={(event) => {
                              if (loading) {
                                event.preventDefault();
                                return;
                              }
                              event.stopPropagation();
                              dragIndexRef.current = index;
                              setDraggingIndex(index);
                              setHoveredIndex(null);
                              if (event.dataTransfer) {
                                event.dataTransfer.effectAllowed = "move";
                                event.dataTransfer.setData("text/plain", `${procedureId}`);
                              }
                            }}
                            onDragEnd={() => {
                              dragIndexRef.current = null;
                              setDraggingIndex(null);
                              setHoveredIndex(null);
                            }}
                            style={{
                              cursor: loading ? "default" : "grab",
                              opacity: 0.65,
                              display: "inline-flex"
                            }}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="11" height="11">
                              <path
                                fill="currentColor"
                                d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z"
                              />
                            </svg>
                          </span>
                          <div>
                            <div>{procedure.procedure_title || "-"}</div>
                            <div style={{ color: "#9ca3af", fontSize: "12px" }}>
                              {procedure.document_number || "-"}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        {(procedure.procedure_application
                          && procedure.procedure_application.data
                          && procedure.procedure_application.data.scenario
                          && procedure.procedure_application.data.scenario.text) || "-"}
                      </td>
                      <td>
                        {(procedure.procedure_application
                          && procedure.procedure_application.data
                          && procedure.procedure_application.data.objective
                          && procedure.procedure_application.data.objective.text) || "-"}
                      </td>
                      <td>
                        <div className="d-flex justify-content-center">
                          <Field
                            name={`plans[${planIndex}].procedures[${index}].checked`}
                            component={CustomCheckbox}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
